import styled from 'styled-components';

export const GuidesMainBanner = styled.section`

    @media screen and (max-width: 1024px){
        padding-top: 128px;
    }

    @media screen and (max-width: 991px){
        padding-top: 105px;
    }
    .row{
        align-items: center;

        .search-header{
            display: none;
        }
    }
    .left_banner{
        margin-bottom: 0px;
    }
`;
export const GuidesMain = styled.section`
    background: #F1FEFF; 
    padding-top: 57px;
    padding-bottom: 50px;

    @media screen and (max-width: 991px){
        padding: 50px 0px;
    }

    @media screen and (max-width: 767px){
        padding: 40px 0px;
    }
    @media screen and (max-width: 575px){
        padding: 30px 0px;
    }

    .blog_title{
        display: none;
    }
    .card{
        .card-body{
            span{
                display: none;
            }
        }
        .giving-guides-blog-pre{
            min-height: 80px;
            height: 100%;
            -webkit-line-clamp: 6;
            @media screen and (max-width: 575px){
                min-height: inherit;
            }
        }
        .giving-guides-blog-btn{
            display: block;
            margin-top: 20px;

            .btn-outline-success-blue{
                width: 100%;
                padding: 12px 20px;
            }
        }
    }
`;
export const GuidesInnerDonate = styled.div`
    margin-bottom: 50px;

    @media screen and (max-width: 991px){
        margin-bottom: 10px;
    }
    @media screen and (max-width: 575px){
        margin-bottom: 30px;
    }
`;
export const GuidesTextBlock = styled.div`
    margin-bottom: 30px;
`;
export const GuidesTitle = styled.h2`
    color: #000000;
    font-family: "Jost", sans-serif;
    font-size: 30px;
    font-weight: 500;
    line-height: normal;
    margin-bottom: 20px;

    @media screen and (max-width: 991px){
        font-size: 28px;
    }
    @media screen and (max-width: 767px){
        font-size: 26px;
        margin-bottom: 15px;
    }
    @media screen and (max-width: 575px){
        font-size: 24px;
    }
    @media screen and (max-width: 480px){
        font-size: 22px;
    }
`;
export const GuidesPre = styled.p`
    font-family: "Jost", sans-serif;
    font-size: 18px;
    font-weight: 400;
    line-height: 28px;
    margin-bottom: 0px;

    a{
    text-decoration:none;
    }

    span{
        color: #01606F;
        font-weight: bold;
        cursor: pointer;
    }
`;

export const GuidesInnerNonProfit = styled.div`
    .container{
        max-width: 996px;
    }
`;
export const GuidesColNonProfit = styled.div`
    background: #FFFFFF;
    box-shadow: 0px 10px 30px #00000014;
    border-radius: 20px;
    padding: 20px 25px;
    display: flex;
    align-items: center;
    column-gap: 30px;

    @media screen and (max-width: 991px){
        max-width: 100%;
        margin: 0 15px; 
    }
    @media screen and (max-width: 575px){
        padding: 25px 15px;
        row-gap: 20px;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        text-align: center;
        border-radius: 15px;
    }
`;
export const GuidesNonProfitImage = styled.div`
    img{
        width: 100%;
    }
`;
export const GuidesNonProfitTextBox = styled.div`
    button{
        padding: 13px 37px;  
        
        @media screen and (max-width: 390px){
            padding: 10px;
            font-size: 14px;
            border-radius: 7px;
        }
    }
`;
export const GuidesNonProfitPre = styled.h3`
    color: #333333;
    font-family: "Jost", sans-serif;
    font-size: 30px;
    font-weight: bold;
    line-height: 45px;
    margin-bottom: 30px;

    @media screen and (max-width: 991px){
        font-size: 28px;
        line-height: 40px;
    }

    @media screen and (max-width: 767px){
        font-size: 24px;
        line-height: 36px;
        margin-bottom: 20px;
    }

    @media screen and (max-width: 767px){
        font-size: 22px;
        line-height: 34px;
        margin-bottom: 15px;
    }
`;
export const GuidesHolidayGiving = styled.div`
    padding-top:70px;

    @media screen and (max-width: 991px){
        padding-top:50px;
    }
    @media screen and (max-width: 767px){
        padding-top:40px;
    }

    @media screen and (max-width: 575px){
        padding-top:30px;
    }
    
    .donation-title{
        display:none;
    }  
`;

export const  GuidesHolidayTitle = styled.h3`
    color: #333333;
    font-family: "Jost", sans-serif;
    font-size: 30px;
    font-weight: 500;
    line-height: 27px;
    margin-bottom: 30px;
    text-align:center;

    @media screen and (max-width: 575px){
        font-size: 24px;
        line-height: 30px;
        margin-bottom: 20px;
    }
`;

export const GuidesHolidayGivingButton = styled.div`
    text-align: center;
    margin-top: 30px;
    
    .btn-outline-success-blue{
        padding: 12px 38px;
    }
`;

export const  GuidesHolidayGroup = styled.div`  
    width: 100%;
    display: flex;
    justify-content: flex-start;
    align-items: stretch;
    column-gap: 24px;

    @media screen and (max-width: 991px){
        column-gap: 15px;
    }

    @media screen and (max-width: 575px){
        flex-direction: column;
        row-gap: 20px;
    }
`;

export const  GuidesHolidayBox = styled.div`
    width: calc(33.33% - 10px);
    background: #D4ECEE;
    padding: 25px;
    border-radius: 20px;
    display: flex;
    justify-content: flex-start;
    flex-direction: column;
    align-items: flex-start;
    text-align: center;

    @media screen and (max-width: 991px){
        padding: 20px 15px;
    }
    @media screen and (max-width: 575px){
        width: 100%;
    }
`;

export const  GuidesHolidayImage = styled.div`
    max-width: max-content;
    max-height: 190px;
    height: 100%;
    margin: 0 auto 30px;

    @media screen and (max-width: 991px){
        max-height: 150px;
    }

    @media screen and (max-width: 575px){
        margin: 0 auto 20px;
    }

    img{
        width: 100%;
        height: 100%;
        display: block;
        object-fit: contain;
    }
`;

export const  GuidesHolidayContent = styled.div`
    width: 100%;
    color: #000000;
    font-size: 14px;
    font-family: 'Jost', sans-serif;
    font-weight: 400;
    line-height: 22px;
`;

export const  GuidesHolidayHeading = styled.h3`
    color: #000;
    font-size: 24px;
    font-family: 'Jost', sans-serif;
    font-weight: 500;
    line-height: 34px;
    margin-bottom: 17px;

    @media screen and (max-width: 991px){
        font-size: 22px;
        line-height: 30px;
    }
`;

export const  GuidesHolidayText = styled.p`
    margin-bottom: 15px;

    &:last-child{
        margin-bottom: 0px;
    }
`;
